const getters = {
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  size: state => state.app.size,
  device: state => state.app.device,
  theme: state => state.tangoEnv.theme,
  pageSize: state => state.app.pageSize,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  userLogo: state => state.user.userInfos.userLogo,
  name: state => state.user.name,
  status: state => state.user.status,
  roles: state => state.user.roles,
  setting: state => state.user.setting,
  permission_routers: state => state.permission.routers,
  addedRouters: state => state.permission.addedRouters,
  errorLogs: state => state.errorLog.logs,
  isNeedToChangePassword: state => state.user.needToChangePassword,
  activeMenu: state => state.user.activeMenu,
  lastLogin: state => state.user.lastLogin,
  lastPassword: state => state.user.lastPassword,
  lastLocale: state => state.user.lastLocale,
  userStatusList: state => state.user.userStatusList,
  userInfos: state => state.user.userInfos,
  isAdmin: state => state.user.userInfos.isAdmin,
  currentUserLogin: state => state.user.userInfos.login,
  countryList: state => state.user.countryList,
  brokerList: state => state.user.brokerList,
  functionList: state => state.user.functionList,
  showUserAccount: state => state.user.showUserAccount,
  optionInformations: state => state.user.optionInformations,
  themeUse: state => state.user.userInfos.theme,
  unreadMessages: state => state.user.unreadMessages,
  isLoggedIn:  state => state.user.userInfos.permissions, //S06: FIXME
  userPermission: state => state.user.userInfos.permissions,
  userPermissionBroker: state => state.user.userInfos.permissionBrokers,
  notificationList: state => state.user.notificationList,
  notificationActive: state => state.user.notificationActive,
  tangoConfig: state => state.tangoEnv.config,
  tangoStatus: state => state.tangoEnv.status,
  selectedEnvIndex: state => state.tangoEnv.selectedEnvIndex,
  canChooseEnv: state => state.tangoEnv.config.canChooseEnv,
  envList: state => state.tangoEnv.config.envList,
  selectedEnv: state => {
    let idx = localStorage.getItem('selectedEnvIndex') || state.tangoEnv.selectedEnvIndex
    if (state.tangoEnv.config.envList && idx >= 0 && idx < state.tangoEnv.config.envList.length) {
      return state.tangoEnv.config.envList[idx]
    }
    else {
      return null
    }
  },
  resultMessage: state => state.message,
  // riskConfig:
  themeList: state => state.settings.themeList,
  heartbeatDelay: state => state.user.userInfos.heartbeatDelay,
  bookList: state => state.iRiskMonitor.bookList,
  instrumentList: state => state.iRiskMonitor.instrumentList,
  accountList: state => state.iRiskMonitor.accountList,
  bookSetList: state => state.iRiskMonitor.bookSetList,
  bookAssetList: state => state.iRiskMonitor.bookAssetList,
  sounds: state => state.soundLibrary.sounds,
  getSoundById: (state) => (id) => {
    return state.soundLibrary.sounds.find(sound => sound.id === id)
  }
}
export default getters
